import * as React from "react"
import { StyleProp, TextStyle, View, ViewStyle, ScrollView, RefreshControl, ImageStyle } from "react-native"
import { observer } from "mobx-react-lite"
import { color } from "../../theme"
import { Text } from "../text/text"
import { AutoImage } from "../auto-image/auto-image"
import { TxKeyPath } from "../../i18n"

const CONTAINER: ViewStyle = {
  justifyContent: "center",
}

const MAIN: ViewStyle = {
  flex: 1,
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: color.palette.white,
}

const IMG_CONTAINER: ViewStyle = {
  flex: 1,
  alignItems: 'center'
}

const IMG: ImageStyle = {
  height: '25%',
  resizeMode: 'contain',
}

const TEXT: TextStyle = {
  color: color.palette.darkestGrey,
  marginTop: 20
}

const SUBTEXT: TextStyle = {
  color: color.palette.grey,
  marginTop: 10,
  textAlign: 'center',
  marginHorizontal: 20
}


export interface OfflineBackgroundProps {
  /**
   * An optional style override useful for padding & margin.
   */
  style?: StyleProp<ViewStyle>
  refreshing?: boolean
  onRefresh?: () => void
  title?: TxKeyPath
  subtitle?: string
}

/**
 * Describe your component here
 */
export const OfflineBackground = observer(function OfflineBackground(props: OfflineBackgroundProps) {
  const { style, title, onRefresh, refreshing, subtitle } = props
  const styles = Object.assign({}, CONTAINER, style)
  const img = require("./offline-bg.png");

  return (
    <ScrollView
      contentContainerStyle={MAIN}
      refreshControl={
        onRefresh && <RefreshControl onRefresh={onRefresh} refreshing={refreshing} />
      }
    >
      <View style={IMG_CONTAINER}>
        <AutoImage source={img} style={IMG} />
        <Text preset="title1" tx={title} style={TEXT} />
        {subtitle && <Text preset="title3" text={subtitle} style={SUBTEXT} />}
      </View>
    </ScrollView>

  )
})
